import styled from 'styled-components';

import { colors } from 'ui/theme';

import { IdDisplay } from './IdDisplay';

interface UserEventDisplayProps {
  id: number;
  name: string;
}

const UserEventNameWrapper = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: minmax(min-content, max-content);
  grid-template-rows: min-content;
  width: 100%;
`;

const UserEventNameLabel = styled.span`
  color: ${colors.textPrimary};
`;

export const UserEventDisplay = ({ id, name }: UserEventDisplayProps) => (
  <UserEventNameWrapper data-test={`user-event-display-${id}`}>
    <UserEventNameLabel>
      {name}
      <IdDisplay id={id} />
    </UserEventNameLabel>
  </UserEventNameWrapper>
);
